import { jobModelLabel } from "../utils/jobLabels";

/** @param {object} job */
export function jobToProjectClip(job) {
  const url = String(job?.video_url || "").trim();
  if (!url) return null;
  return {
    url,
    duration: Math.max(1, Math.round(Number(job.duration_sec) || 5)),
    modelId: job.ui_model || "",
    modelLabel: jobModelLabel(job.ui_model),
    outputResolution: job.resolution || null,
    jobId: job.id,
    thumbnailUrl: url,
  };
}
